<template>
  <section class="section">
    <div class="container items-center">
      <h3 class="section__h3 mb-5">Designed for career experiences</h3>
      <p class="section__p mb-base">Activate Organization Mode to see how GetBoarded can help you and your employees to manage career choices keeping future in mind. A talent management tool with features that will convince you to use it as SaaS for your business.</p>
      <vs-row class="container personality-row" vs-type="flex">
        <vs-col class="sm:w-full lg:w-1/3 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/company-features/finding-workforce.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Finding Workforce</h4>
              <p class="feature-description mb-5">Find people fitting your job role requirement with skill and personality fitment. Match candidates to your culture before hiring. Find intern, employee, volunteer or remote talent.</p>
              <vs-button class="w-full" color="#F29300">Hire</vs-button>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/3 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/company-features/manage-talent.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Manage Talent</h4>
              <p class="feature-description mb-5">Manage succession with training need analysis and leadership identification with quantifiable metrics. Predictive Talent Analysis and Success Probability Scores to direct employee careers.</p>
              <vs-button class="w-full" color="#F29300">Fit</vs-button>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/3 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 items-center">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/company-features/retention-framework.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="items-center">
              <h4 class="feature-title mb-3">Retention Framework</h4>
              <p class="feature-description mb-5">A smart prediction mechanism to identify the situational responses for employees. Personality based private guides for preparation and response.</p>
              <vs-button class="w-full" color="#F29300">Grow</vs-button>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  import personality_data from '../../../../src/assets/data/personality.js';

  export default {
    name: "Features",
    data() {
      return {
        personality_data: personality_data
      }
    }
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }

  button {
    border-radius: 50px;
  }

  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    width: 65%;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    /* or 150% */
    text-align: center;
    color: #848199;
  }

  /*===============================================*/
  /* PERSONALITY	 						 */
  /*===============================================*/

  .leaf {
    position: absolute;
    left: 0;
    top: 0;
    width: 500px;
  }

  .personality-row {
    /*margin-top: 10rem;*/
    width: 85%!important;
  }

  .personality-card {
    min-height: 350px;
    z-index: 999;
    box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  }

  .feature-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;

    flex: none;
    order: 0;
    align-self: flex-start;
    flex-grow: 0;
    margin: 0px 0px;
    color: #231D4F;
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: flex-start;
    flex-grow: 0;
    color: #848199;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem 5rem 2rem;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf {
      width: -webkit-fill-available;
      width: -moz-available;
    }

  }
</style>
